import { Space, Tag, Tooltip } from "antd";
import { TimestampCell } from "../../common/TimestampCell";
import { CopyableText } from "../../common/CopyableText";
import { WaterTypeBadge } from "../../common/WaterTypeBadge";
import {
  getPrimarySnapshotValue,
  getReadoutIsLate,
  getReadoutStatus,
  getReadoutTimestamp,
  splitMeterStatus,
  statusSortValue,
} from "../readoutFormat";

const renderPrimaryValue = (value: number | null | undefined): string => {
  if (value == null) {
    return "N/A";
  }
  return value.toFixed(2);
};

export const allColumns = () => [
  {
    title: "Meter Name",
    dataIndex: "name",
    key: "name",
    width: 200,
    sorter: true,
    render: (name: string) => <CopyableText text={name} />,
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    width: 88,
    sorter: (a: any, b: any) =>
      statusSortValue(getReadoutStatus(a), getReadoutIsLate(a)) -
      statusSortValue(getReadoutStatus(b), getReadoutIsLate(b)),
    render: (_: unknown, record: any) => {
      const parsed = splitMeterStatus(getReadoutStatus(record), getReadoutIsLate(record));
      const freshnessTag = (
        <Tag color={parsed.isLate ? "red" : "green"}>
          {parsed.isLate ? "LATE" : "OK"}
        </Tag>
      );
      if (parsed.vendor.length === 0) {
        return freshnessTag;
      }

      const vendorTag = (
        <Tooltip title={parsed.vendor.join(", ")}>
          <Tag color="gold">VENDOR</Tag>
        </Tooltip>
      );

      if (parsed.isLate) {
        return (
          <Space direction="vertical" size={2}>
            {freshnessTag}
            {vendorTag}
          </Space>
        );
      }
      return vendorTag;
    },
  },
  {
    title: "Primary Value",
    dataIndex: "primary_value",
    key: "primary_value",
    width: 140,
    sorter: true,
    render: (_value: number | null, record: any) =>
      renderPrimaryValue(getPrimarySnapshotValue(record)),
  },
  {
    title: "Timestamp",
    dataIndex: "latest_readout_timestamp",
    key: "latest_readout_timestamp",
    width: 160,
    sorter: true,
    render: (_value: string, record: any) => (
      <TimestampCell value={getReadoutTimestamp(record) ?? ""} />
    ),
  },
  {
    title: "Media",
    dataIndex: "media",
    key: "media",
    width: 180,
    sorter: true,
    render: (value: string, record: any) => {
      if (value === "water") {
        return (
          <Space size={4}>
            <Tag>{value}</Tag>
            <WaterTypeBadge isHot={record.hot} />
          </Space>
        );
      }
      return <Tag>{value}</Tag>;
    },
  },
  {
    title: "UUID",
    dataIndex: "uuid",
    key: "uuid",
    width: 150,
    sorter: true,
    render: (value: string | null) => (
      <CopyableText text={value} display={value ? `${value.slice(0, 8)}...` : undefined} />
    ),
  },
  {
    title: "Address",
    dataIndex: "address",
    key: "address",
    width: 160,
    sorter: true,
    render: (value: string | null) => value ?? "N/A",
  },
  {
    title: "Serial",
    dataIndex: "serial",
    key: "serial",
    width: 160,
    sorter: true,
    render: (value: string | null) => value ?? "N/A",
  },
];
